import {isValid, isPast} from 'date-fns';

import Text from 'assets/icons/text.svg';
import Video from 'assets/icons/video.svg';
import Link from 'assets/icons/link.svg';
import Choice from 'assets/icons/choice.svg';
import Meeting from 'assets/icons/agenda.svg';
import Image from 'assets/icons/image.svg';
import OpenQuestion from 'assets/icons/open-question.svg';

import {COMPONENT_TYPES} from './constants';
import {ComponentType, Component} from './types';
import {isUrl, isYoutubeLink} from 'utils/checks';

export const selectImageFile = (type?: ComponentType) => {
  switch (type) {
    case COMPONENT_TYPES.TEXT:
      return Text;
    case COMPONENT_TYPES.IMAGE:
      return Image;
    case COMPONENT_TYPES.VIDEO:
      return Video;
    case COMPONENT_TYPES.MEETING:
      return Meeting;
    case COMPONENT_TYPES.LINK:
      return Link;
    case COMPONENT_TYPES.MULTIPLE_CHOICES:
      return Choice;
    case COMPONENT_TYPES.OPEN_QUESTION:
      return OpenQuestion;
    default:
      return undefined;
  }
};

export const componentName = (type?: ComponentType) => {
  switch (type) {
    case COMPONENT_TYPES.TEXT:
      return 'Tekst';
    case COMPONENT_TYPES.IMAGE:
      return 'Afbeelding';
    case COMPONENT_TYPES.VIDEO:
      return 'YouTube video';
    case COMPONENT_TYPES.LINK:
      return 'Link';
    case COMPONENT_TYPES.MULTIPLE_CHOICES:
      return 'Meerkeuzevraag';
    case COMPONENT_TYPES.OPEN_QUESTION:
      return 'Open vraag';
    case COMPONENT_TYPES.MEETING:
      return 'Live meeting';
    default:
      return undefined;
  }
};

export const selectDefaultValue = (type?: ComponentType) => {
  const result: Partial<Component> = {
    value: '',
    dateValue: undefined,
    choices: [],
  };

  switch (type) {
    case COMPONENT_TYPES.TEXT:
      result.value = 'Tekst';
      break;
    case COMPONENT_TYPES.IMAGE:
      result.value = 'Afbeelding';
      break;
    case COMPONENT_TYPES.VIDEO:
      result.value = 'http://youtube.com/watch?v=';
      break;
    case COMPONENT_TYPES.LINK:
      result.value = 'https://google.com';
      break;
    case COMPONENT_TYPES.MULTIPLE_CHOICES:
      result.value = 'Meerkeuzevraag';
      result.choices = [
        {
          key: 0,
          text: 'Option 1',
          isAnswer: true,
        },
      ];
      break;
    case COMPONENT_TYPES.OPEN_QUESTION:
      result.value = 'Open vraag';
      break;
    case COMPONENT_TYPES.MEETING:
      result.dateValue = new Date();
      break;
  }

  return result;
};

export const validateComponent = (
  component: Partial<Component>,
  callback: () => void
) => {
  const {type, value, dateValue, choices, imageId, caption} = component;

  switch (type) {
    case COMPONENT_TYPES.TEXT:
    case COMPONENT_TYPES.OPEN_QUESTION: {
      if (!value) {
        callback();
      }
      break;
    }
    case COMPONENT_TYPES.MULTIPLE_CHOICES: {
      if (!choices || choices.length <= 1) {
        callback();
      } else {
        const {hasText} = choices.reduce(
          (acc: {hasText: boolean}, {text}) => {
            return {
              hasText: acc.hasText && !!text,
            };
          },
          {
            hasText: true,
          }
        );

        if (!hasText) {
          callback();
        }
      }

      break;
    }
    case COMPONENT_TYPES.LINK: {
      if (!value || !isUrl(value)) {
        callback();
      }

      if (!caption) {
        callback();
      }
      break;
    }
    case COMPONENT_TYPES.VIDEO: {
      if (!value || !isYoutubeLink(value)) {
        callback();
      }
      break;
    }
    case COMPONENT_TYPES.MEETING: {
      if (!dateValue) {
        callback();
      } else {
        try {
          const valid = isValid(dateValue) && !isPast(dateValue);

          if (!valid) {
            callback();
          }
          /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
        } catch (error: any) {
          console.log(error);
          callback();
        }
      }
      break;
    }
    case COMPONENT_TYPES.IMAGE: {
      if (!imageId) {
        callback();
      }
    }
  }
};
